import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import CertificateHandler from './CertificateHandler';
import { Routes, Route as R, BrowserRouter } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';

mixpanel.init('70430c8cb070f9f9b9b2552a185735c0', { debug: true });
mixpanel.track('Checkout Page');

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <R path=":nft_pkey" element={<CertificateHandler />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
